export default __webpack_public_path__ + "static/media/news3.5d5fdd4e.jpeg";